export const getters = {
  confiseries (state) {
    return state.confiseries
  },
  confiserie (state) {
    return state.confiserie
  },  
  pagination(state){
    return state.pagination
  }
}
